import { render, staticRenderFns } from "./CallUpdateNameAutoCall.vue?vue&type=template&id=70d185dc"
import script from "./CallUpdateNameAutoCall.vue?vue&type=script&lang=js"
export * from "./CallUpdateNameAutoCall.vue?vue&type=script&lang=js"
import style0 from "./CallUpdateNameAutoCall.vue?vue&type=style&index=0&id=70d185dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports